import { Box, Skeleton } from '@mui/material';

const SkeletonLoading = () => {
    return (
        <Box>
            <Skeleton animation="wave" variant="rounded" height='2rem' width='88%' sx={{ marginBottom: '1.2rem' }} />
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' }, gap: { xs: '.9rem 1.5rem', md: '1rem 2%' } }}>
                {Array.from({ length: 4 }).map((_, index) =>
                    <Box key={index}>
                        <Skeleton animation="wave" variant="rounded" height='7.93rem' sx={{ borderRadius: '.38rem', marginBottom: '.7rem' }} />
                        <Skeleton animation="wave" variant="rounded" height='2.18rem' sx={{ borderRadius: '.31rem' }} />
                    </Box>
                )}
            </Box>

            <Box sx={{ display: 'flex', margin: '1.7rem 0 1.1rem', alignItems: 'center', gap: '.8rem' }}>
                <Skeleton animation="wave" variant="rounded" height='2.18rem' width='.25rem' />
                <Skeleton animation="wave" variant="rounded" height='1.5rem' width='70%' />
            </Box>
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' }, gap: { xs: '1.3rem', md: '3.8%' }, justifyContent: 'space-between' }}>
                {Array.from({ length: 3 }).map((_, index) =>
                    <Box key={index}>
                        <Skeleton animation="wave" variant="rounded" height='17.5em' sx={{ borderRadius: '.38rem', marginBottom: '.7rem' }} />
                        <Skeleton animation="wave" variant="rounded" height='2.18rem' sx={{ borderRadius: '.31rem' }} />
                    </Box>
                )}
            </Box>
        </Box>
    );
}

export default SkeletonLoading;